// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__HqppK","imageUploader":"EGiftCard_imageUploader__6u04x"};